//Components
import Layout from '../../hocs/Layout';
import { Link, useLocation } from 'react-router-dom';
import { WhatsAppButton } from '../../components/aditional/WhatsApp';
import { useEffect, useRef, useState } from 'react';
import emailjs from '@emailjs/browser';
//Styles
import '../../styles/static-pages.css';
//Icons
import { FaArrowRightLong, FaCheck } from "react-icons/fa6";
import { IoClose } from "react-icons/io5";


export const PriceForm = ({ toggleOpen, openPriceForm }) => {

    const form = useRef();
    const [sendedEmail, setSendedEmail] = useState(false);

    const sendEmail = (e) => {
        e.preventDefault();

        emailjs
            .sendForm('service_mwgltv9', 'template_sco1pyb', form.current, {
                publicKey: '22tKECBM3o4X0FoPS',
            })
            .then(
                () => {
                    console.log('SUCCESS!');
                    setSendedEmail(true);
                    form.current.reset();
                },
                (error) => {
                    console.log('FAILED...', error.text);
                },
            );
    };

    return (

            <form className={`container-price-form ${openPriceForm ? 'form-open' : ''}`} ref={form} onSubmit={sendEmail}>
                <div className={`contain-price-form ${openPriceForm ? 'price-form-open' : ''}`}>
                    <button className='button-close-price' onClick={toggleOpen}><IoClose /></button>
                    <h2 className='price-form-title'>Cuentanos de tu proyecto</h2>
                    <div className='contain-inputs-contact'>
                        <div className='input-contact'>
                            <input
                                type='text'
                                name='user_name'
                                className='input-contact-form'
                                required
                            />
                            <span>Nombre</span>
                        </div>
                        <div className='input-contact'>
                            <input
                                type='email'
                                name='user_email'
                                className='input-contact-form'
                                required
                            />
                            <span>Email o Teléfono</span>
                        </div>
                        <select className='select-price-form'>
                            <option>Diseño web</option>
                            <option>Diseño de marca</option>
                            <option>Marketing Digital</option>
                        </select>
                        <div className='input-contact'>
                            <input 
                                type='text' 
                                name='subject' 
                                className='input-contact-form' 
                                required 
                            />
                            <span>Presupuesto aproximado</span>
                        </div>
                        <div className='input-contact-msg'>
                            <textarea name='message' className='input-contact-form' required></textarea>
                            <span>Descripción</span>
                        </div>
                        <p className='required-fields'>Todos los campos son obligatorios</p>
                        <div className='container-submit-button'>
                            {sendedEmail ? (
                                <p className='submited-contact-button'>Enviado</p>
                            ) : (
                                <button type='submit' className='btn btn1'>
                                    <span>Enviar</span>
                                </button>
                            )}
                        </div>
                        <div className='container-form-wpp'>
                            <p>¿Preferís hablar directo?</p><Link to='https://wa.me/+543574511196?text=Hola,%20me%20interesa%20recibir%20más%20información%20acerca%20del%20sus%20de%20servicios.' target='_blank' className='wpp-form-link' style={{textDecoration: 'none'}}>Escribinos por WhatsApp</Link>
                        </div>
                    </div>
                </div>
            </form>
    )
}